var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"TertiaryNav"}},[_c('b-container',[_c('p',[_vm._v(" Luxury Awaits: 2023 US Open Individual Session Hospitality Ticket Packages are now available for purchase. ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }